<template>
  <div class="usage-stats-content">
    <p class="title">{{ content.title }}</p>
    <div class="subtitle">
      {{ content.subtitle }}
      <div class="tooltip-container" v-if="content.options.info">
        <i class="material-icons">&#xE88F;</i>
        <div class="tooltip tooltip-top" role="tooltip">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-inner">
            {{ content.options.info }}
          </div>
        </div>
      </div>
    </div>
    <div class="status">
      <p>{{ $t(content.status) }}</p>
      <i
        class="material-icons"
        v-if="content.options.hasDeclined"
        :class="{ 'has-text-warning': content.options.hasWarning }"
        >&#xE5C5;</i
      >
      <i
        class="material-icons"
        v-else
        :class="{ 'has-text-warning': content.options.hasWarning }"
        >&#xE5C7;</i
      >
    </div>
    <simple-line-chart
      :data="content.data"
      :tooltip-title="content.subtitle"
      :class="{ 'is-warning': content.options.hasWarning }"
    />
  </div>
</template>

<script>
import SimpleLineChart from 'views/charts/SimpleLineChart';

export default {
  name: 'UsageStatsContent',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  components: {
    SimpleLineChart,
  },
};
</script>

<style lang="scss">
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.usage-stats-content {
  .title,
  .subtitle {
    color: $black-bis;
  }

  .title {
    font-size: $size-large;
    font-weight: $weight-medium;
    line-height: 1.21;
  }

  .subtitle {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    line-height: 1.43;

    &:not(:last-child) {
      margin-bottom: 0.5rem;
    }

    .tooltip-container {
      display: flex;
      margin-left: 0.25rem;
    }

    i {
      font-size: 0.875rem;
    }
  }

  .status {
    display: flex;
    font-size: $size-small;
    line-height: 1.67;

    p {
      opacity: 0.64;
      margin-bottom: 0.75rem;
    }

    i {
      margin-left: 0.25rem;
      font-size: $size-normal;
      line-height: 1.25;
    }
  }

  .simple-line-chart {
    width: 100%;
    height: 1.25rem;
  }
}
</style>
